import { Icon } from '@clarion/ClarionIcon';
import { Children, Fragment, HTMLAttributes, ReactNode } from 'react';
import { cx } from '../util';

type Props = HTMLAttributes<HTMLHeadingElement> & {
  children: ReactNode;
};

export const H1 = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cx('text-xl md:text-2xl xl:text-3xl font-semibold', className)} {...props}>
    {children}
  </h1>
);

export const H2 = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={cx('text-lg md:text-xl xl:text-2xl font-semibold', className)} {...props}>
    {children}
  </h2>
);

export const H3 = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h3 className={cx('text-base md:text-lg xl:text-xl font-semibold', className)} {...props}>
    {children}
  </h3>
);

export const H4 = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h4 className={cx('text-sm md:text-base xl:text-lg font-semibold', className)} {...props}>
    {children}
  </h4>
);

export const H5 = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h5 className={cx('font-semibold', className)} {...props}>
    {children}
  </h5>
);

export default function Breadcrumbs({ children, className, style, ...props }: Props) {
  const crumbs = Children.toArray(children);
  return (
    <H1
      className={cx(
        'shrink-0 wrap-break-word min-w-0 max-w-full my-5 flex flex-wrap gap-2 items-center xl:items-baseline ',
        className,
      )}
      style={{ wordBreak: 'break-word', ...style }}
      {...props}
    >
      {crumbs.filter(Boolean).map((child, i) => (
        <Fragment key={i}>
          {i > 0 && <Icon icon="chevron-right" />}
          {i > 0 && ' '}
          {child}
        </Fragment>
      ))}
    </H1>
  );
}
